import {
  Button,
  FormControlLabel,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  CircularProgress,
} from "@mui/material";
import FlagIcon from "@mui/icons-material/Flag"; // Örnek olarak bayrak ikonu
import { Field, Form, Formik } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import GayrimenkulBulPopUp from "../../../components/OB/PopUp";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import { MuiTelInput } from "mui-tel-input";
import { istekSikayetValidationSchema } from "../../../validations/EmlakBasvuru";
import BasvuruTuruAPI from "../../../apis/OB/Get/BasvuruTuruAPI";
import KonuBasligiListeAPI from "../../../apis/OB/Get/KonuBasligiListeAPI";
import BasvuruNedeniListeAPI from "../../../apis/OB/Get/BasvuruNedeniListeAPI";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import SessionStorageService from "../../../services/StorageService";
import IstekSikayetSaveAPI from "../../../apis/OB/SaveApi/IstekSikayetSaveAPI";
import { safelyParseNumber } from "../../../helpers/MoneyFormat";
import CustomTextField from "../../../components/OB/required-text-field";
import CustomMuiTelInput from "../../../components/OB/required-muitelinput";
import { toast } from "react-toastify";
import CustomAutocomplete from "../../../components/OB/popups/required-auto-complete";
import { filterOptions } from "../../../helpers/TodayDate";
import DysAPI from "../../../apis/DysAPI";
import Recaptcha from "../../../components/Recaptcha";
const IstekSikayetBasvuru = (props: any) => {
  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);


  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupbasvuruMetni, setPopupbasvuruMetni] = useState("");
  const [kayitBasarili, setKayitBasarili] = useState(false);
  let user = SessionStorageService.getUserInfo();
  console.log(user);
  const closePopupSonuc = () => {
    setIsPopupVisible(false);
    setPopupbasvuruMetni("");
  };
  const [open, setOpen] = useState(false);
  const openPopup = () => {
    setOpen(true);
  };
  const { mahalleListe } = useContext(ConstantAPISContext);

  const closePopup = () => {
    setOpen(false);
  };
  const [selectedMahalleKodu, setSelectedMahalleKodu] = useState<number | null>(
    null
  );
  const [documents, setDocuments] = useState<any[]>([]);
  const [docsLoaded, setDocsLoaded] = useState<boolean>(false);
  const documentTableRef = useRef<HTMLDivElement | null>(null);

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  const handleUpdateDocuments = (updatedDocuments: any) => {
    setDocuments(updatedDocuments);
  };

   useEffect(() => {
    setDocsLoaded(false);

    DysAPI.obBasvuruTanimBelgeList({ rfObBasvuruTanim: -1 })
      .then((res: any) => {
        console.log("Belge listesi response:", res.data);

        const list = (res?.data ?? []).map((b: any, idx: number) => {
          const zorunlu = (b.zorunluEh)
            .toString();

          return {
            id: b.sqId,
            documentName: b.belgeAdi,
            isRequired: ["E"].includes(zorunlu),
            fileName: "",
            file: null,
          };
        });

        setDocuments(list);
      })
      .catch((err: any) => {
        console.error("Belge listesi hatası:", err);
        setDocuments((prevDocs: any[]) =>
          prevDocs.map((doc) => ({
            ...doc,
            file: null,
            fileName: "",
          }))
        );
      })
      .finally(() => {
        setDocsLoaded(true);
      });
  }, []);

  const [caddeListe, setCaddeListe] = useState<any[]>([]);
  const [basvuruNedeniList, setBasvuruNedeniList] = useState<any[]>([]);
  const [konuBasligiList, setKonuBasligiList] = useState<any[]>([]);
  useEffect(() => {
    BasvuruNedeniListeAPI.getBasvuruNedeniListeListe(undefined)
      .then((res) => {
        setBasvuruNedeniList(res.data);
      })
      .catch(() => {
        console.log("hata");
      })
      .finally(() => { });
    KonuBasligiListeAPI.getKonuBasligiListeListe(undefined)
      .then((res) => {
        setKonuBasligiList(res.data);
      })
      .catch(() => {
        console.log("hata");
      })
      .finally(() => { });
  }, []);
  useEffect(() => {
    if (selectedMahalleKodu) {
      CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu)
        .then((res) => {
          setCaddeListe(res.data);
        })
        .catch(() => {
          console.log("hata");
        })
        .finally(() => { });
    } else {
      setCaddeListe([]);
    }
  }, [selectedMahalleKodu]);
  return (
    <Formik
      validationSchema={istekSikayetValidationSchema}
      validateOnMount={true}
      initialValues={{
        basvuruTuruId: -1,
        sicilKodu: user?.sicilKodu,
        adi: user != null ? user.adi : "",
        soyadi: user != null ? user.soyadi : "",
        tckimlikNo: user != null ? user.tcKimlikNo : props.tcKimlikNo,
        gsmKodu: "",
        cepTelefonu: "",
        ePostaAdresi: "",
        basvuruNedeniKodu: "",
        konuBasligiKodu: "",
        mahalleKodu: "",
        caddeSokakKodu: "",
        basvuruMetni: "",
        alanKodu: "",
        sabitTelefon: "",
        ikametgahAdresi: "",
        kapiNo: "",
        altKapiNo: "",
        daireNo: "",
        altDaireNo: "",
        kimlikBilgilerimiGizle: "H",
        smsBildirimiIstiyorum: "H",
        belediyeSiniriIcindeMi: "H",
      }}
      onSubmit={async (values: any, { resetForm }) => {
        const missingDocuments = documents
          .filter(doc => doc.isRequired) // zorunlu belgeler
          .filter(doc => !doc.fileName);     // henüz yüklenmemiş olanlar

        if (missingDocuments.length > 0) {
          const missingDocNames = missingDocuments.map(d => d.documentName).join(", ");
          toast.error(`Lütfen şu zorunlu belgeleri yükleyin: ${missingDocNames}`);
          documentTableRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
          return; // başvuru burada durur
        }

        // reCAPTCHA’yı tetikle
        const token = await recaptchaRef.current?.handleSubmit();
        if (!token) {
          toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
          return;
        }
        
        setLoadingSubmit(true);
        console.log("values", values);
        const transformedValues = {
          ...values,
          ada: values.ada != "" ? safelyParseNumber(values.ada) : null,
          parsel: values.parsel != "" ? safelyParseNumber(values.parsel) : null,
          mahalleKodu: safelyParseNumber(values.mahalleKodu),
          caddeSokakKodu: safelyParseNumber(values.caddeSokakKodu),
          kapiNo: values.kapiNo != "" ? safelyParseNumber(values.kapiNo) : null,
          daireNo: values.daireNo != "" ? safelyParseNumber(values.daireNo) : null,
          tapuCiltNo: values.tapuCiltNo != "" ? safelyParseNumber(values.tapuCiltNo) : null,
          tapuSayfaNo: values.tapuSayfaNo != "" ? safelyParseNumber(values.tapuSayfaNo) : null,
          arsaYuzolcumu: safelyParseNumber(values.arsaYuzolcumu),
          sicilKodu: safelyParseNumber(user?.sicilKodu),

          arsaHisse: safelyParseNumber(values.arsaHisse),
          arsaOran: safelyParseNumber(values.arsaOran),
          arsa2Hisse: safelyParseNumber(values.arsa2Hisse),
          arsa2Oran: safelyParseNumber(values.arsa2Oran),
          tcKimlikNo: values.tckimlikNo.toString(),
          gsmKodu: values.cepTelefonu.replaceAll(" ", "").substring(2, 6),
          cepTelefonu: values.cepTelefonu.replaceAll(" ", "").substring(6, 13),
          alanKodu: values.sabitTelefon.replaceAll(" ", "").substring(2, 6),
          sabitTelefon: values.sabitTelefon.replaceAll(" ", "").substring(6, 13),
          captchaToken: token
        };
        IstekSikayetSaveAPI.saveIstekSikayetBasvuruSave(transformedValues).then(async(res) => {
          console.log(res)
          if (res.data.sonuc === 0) {
            let basvuruNo = res.data.basvuruNo;

            // DYS API'yi çağır 
            try {
              // Sadece dosyası olanları al
              const filesToSend = documents.filter((doc: any) => !!doc.file);

              if (filesToSend.length > 0) {
                const formData = new FormData();

                filesToSend.forEach((doc: any) => {
                  formData.append("files", doc.file, doc.file.name);
                  formData.append("rfObBasvuruTanimBelge", String(doc.id));
                });

                formData.append("basvuruTuru", String(values.basvuruTuruId || 0));
                formData.append("basvuruId", String(basvuruNo));
                formData.append("folderName", "AKOS");
                formData.append("kurumId", "1");
                formData.append("versionable", "1");

                const response = await DysAPI.upload(formData);
                toast.warning(response.message);
              } else {
                // Burada return yok — sadece DYS çağrısını atlıyoruz.
                
              }
            } catch (error: any) {
              toast.error("DYS upload hazırlama hatası:", error);
            }

            setPopupbasvuruMetni(
              "İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " +
              basvuruNo
            );
            resetForm();
            setKayitBasarili(true);
            setDocuments((prevDocs: any[]) =>
              prevDocs.map((doc) => ({
                ...doc,
                file: null,
                fileName: "",
              }))
            );
          } else {
            setPopupbasvuruMetni(res.data.sonucAciklama);

          }
        }).catch((err) => {
          setPopupbasvuruMetni(
            "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
          );
        }).finally(() => {
          setIsPopupVisible(true);
          recaptchaRef.current?.reset();
          setLoadingSubmit(false);
        });
      }}
    >

      {(formikProps) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showToastIfErrorsExist = () => {
          if (Object.keys(formikProps.errors).length > 0) {
            focusFirstErrorField();
            toast.error("Lütfen zorunlu alanları doldurun!");

          }
        };
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const formRefs = useRef<any>({});
        const focusFirstErrorField = () => {
          const errorKeys = Object.keys(formikProps.errors);
          if (errorKeys.length > 0) {
            const firstErrorKey = errorKeys[0];
            console.log(errorKeys[0])
            const element = document.querySelector(`[name="${firstErrorKey}"]`);
            if (element) {
              (element as HTMLElement).focus();
            }
          }
        };
        return (
          <Form onSubmit={formikProps.handleSubmit}>
            <div className="row">
              <div className="col-12 mb-3">
                <div className="d-flex justify-content-end align-self-stretch">
                  <Button
                    type="button"
                    onClick={() => {
                      formikProps.resetForm({ values: formikProps.initialValues });
                      setDocuments((prevDocs: any[]) =>
                        prevDocs.map((doc) => ({
                          ...doc,
                          file: null,
                          fileName: "",
                        }))
                      );
                    }}
                    color="secondary"
                  >
                    Temizle
                  </Button>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-3 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <h5 className="mb-3">
                      BAŞVURU SAHİBİ BİLGİLERİ
                    </h5>
                    <hr className="mb-3" />
                    <div className="row">
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label="Adınız *"
                          error={
                            formikProps.errors.adi && formikProps.touched.adi
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("adi")}
                          variant="outlined"
                        />
                      </div>
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label="Soyadınız *"
                          error={
                            formikProps.errors.soyadi &&
                              formikProps.touched.soyadi
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("soyadi")}
                          variant="outlined"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          disabled={true}
                          label="T.C. Kimlik Numaranız"
                          error={
                            formikProps.errors.tckimlikNo &&
                              formikProps.touched.tckimlikNo
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("tckimlikNo")}
                          variant="outlined"
                        />
                      </div>
                      <div className="col-lg-6">
                        <CustomMuiTelInput
                          name="cepTelefonu"
                          fullWidth
                          defaultCountry="TR"
                          onlyCountries={["TR"]}
                          className="mb-3"
                          size="small"
                          label="Cep Telefonu *"
                          error={
                            (formikProps.errors.cepTelefonu &&
                              formikProps.touched.cepTelefonu)
                              ? true
                              : false
                          }
                          value={formikProps.values.cepTelefonu}
                          onChange={(value: any) => {
                            // +90 ön ekini koruyacak şekilde değeri ayarlıyoruz
                            const prefix = "+90 ";
                            if (!value.startsWith(prefix)) {
                              value = prefix + value.replace(/^\+90/, "");
                            }
                            formikProps.setFieldValue("cepTelefonu", value);
                          }}
                          variant="outlined"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <MuiTelInput
                          fullWidth
                          defaultCountry="TR"
                          onlyCountries={["TR"]}
                          className="mb-3"
                          size="small"
                          label="Sabit Telefonu"
                          value={formikProps.values.sabitTelefon}
                          inputProps={{ maxLength: 17 }}
                          error={
                            formikProps.errors.sabitTelefon &&
                              formikProps.touched.sabitTelefon
                              ? true
                              : false
                          }
                          onChange={(value) => {
                            // +90 ön ekini koruyacak şekilde değeri ayarlıyoruz
                            const prefix = "+90";
                            if (!value.startsWith(prefix)) {
                              value = prefix + value.replace(/^\+90/, "");
                            }
                            formikProps.setFieldValue("sabitTelefon", value);
                          }}
                          variant="outlined"
                        />

                      </div>
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label="E-Posta Adresi *"
                          error={
                            formikProps.errors.ePostaAdresi &&
                              formikProps.touched.ePostaAdresi
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("ePostaAdresi")}
                          variant="outlined"
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <TextField
                          fullWidth
                          multiline
                          rows={5.8}
                          size="small"
                          label="İkametgah Adresiniz"
                          error={
                            formikProps.errors.ikametgahAdresi &&
                              formikProps.touched.ikametgahAdresi
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("ikametgahAdresi")}
                          variant="outlined"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <h5 className="mb-3 font-weight-bold">BAŞVURU BİLGİLERİ</h5>
                    <hr className="mb-3" />
                    <div className="row">
                      <div className="col-lg-6">
                        <CustomTextField
                          name="mahalleKodu"
                          fullWidth
                          className="mb-3"
                          select
                          label="Mahalle *"
                          size="small"
                          error={
                            formikProps.errors.mahalleKodu &&
                              formikProps.touched.mahalleKodu
                              ? true
                              : false
                          }
                          value={formikProps.values.mahalleKodu}
                          onChange={(value: any) => {
                            formikProps.setFieldValue(
                              "mahalleKodu",
                              Number(value.target.value)
                            );
                            setSelectedMahalleKodu(Number(value.target.value));
                            formikProps.setFieldValue("caddeSokakKodu", null);
                          }}
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {mahalleListe.map((option) => (
                            <MenuItem
                              key={option.mahalleKodu}
                              value={option.mahalleKodu}
                            >
                              {option.mahalleAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="caddeSokakKodu"
                          fullWidth
                          className="mb-3"
                          size="small"
                          select
                          label="Cadde/Sokak *"
                          error={
                            formikProps.errors.caddeSokakKodu &&
                              formikProps.touched.caddeSokakKodu
                              ? true
                              : false
                          }
                          value={formikProps.values.caddeSokakKodu}
                          onChange={(value: any) =>
                            formikProps.setFieldValue(
                              "caddeSokakKodu",
                              Number(value.target.value)
                            )
                          }
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {caddeListe.map((option) => (
                            <MenuItem
                              key={option.caddeSokakKodu}
                              value={option.caddeSokakKodu}
                            >
                              {option.caddeSokakAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <CustomTextField
                          name="basvuruNedeniKodu"
                          fullWidth
                          className="mb-3"
                          select
                          label="Başvuru Nedeni *"
                          size="small"
                          error={
                            formikProps.errors.basvuruNedeniKodu &&
                              formikProps.touched.basvuruNedeniKodu
                              ? true
                              : false
                          }
                          value={formikProps.values.basvuruNedeniKodu}
                          onChange={(value: any) => {
                            formikProps.setFieldValue(
                              "basvuruNedeniKodu",
                              Number(value.target.value)
                            );
                          }}
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {basvuruNedeniList.map((option) => (
                            <MenuItem
                              key={option.bavuruNedeniKodu}
                              value={option.bavuruNedeniKodu}
                            >
                              {option.bavuruNedeniAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="konuBasligiKodu"
                          fullWidth
                          className="mb-3"
                          size="small"
                          select
                          label="Konu Başlığı *"
                          error={
                            formikProps.errors.konuBasligiKodu &&
                              formikProps.touched.konuBasligiKodu
                              ? true
                              : false
                          }
                          value={formikProps.values.konuBasligiKodu}
                          onChange={(value: any) =>
                            formikProps.setFieldValue(
                              "konuBasligiKodu",
                              Number(value.target.value)
                            )
                          }
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {konuBasligiList.map((option) => (
                            <MenuItem
                              key={option.konuBasligiKodu}
                              value={option.konuBasligiKodu}
                            >
                              {option.konuBasligiAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label="Kapı No"
                          error={
                            formikProps.errors.kapiNo &&
                              formikProps.touched.kapiNo
                              ? true
                              : false
                          }
                          value={formikProps.values.kapiNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("kapiNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 4) : "")
                          }

                          variant="outlined"
                        />
                      </div>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label="Alt Kapı No"
                          {...formikProps.getFieldProps("altKapiNo")}
                          variant="outlined"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label="Daire No"
                          value={formikProps.values.daireNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("daireNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 4) : "")
                          }
                          variant="outlined"
                        />
                      </div>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label="Alt Daire No"
                          {...formikProps.getFieldProps("altDaireNo")}
                          variant="outlined"
                        />
                      </div>
                      <div className="col-12 mb-3 mb-lg-0">
                        <div className="card w-100">
                          <div className="card-body  w-100">
                            <h6>Belediye Sınırları İçinde mi?</h6>
                            <RadioGroup
                              aria-labelledby="demo-radio-buttons-group-label"
                              {...formikProps.getFieldProps(
                                "belediyeSiniriIcindeMi"
                              )}
                              defaultValue={
                                formikProps.values.belediyeSiniriIcindeMi
                              }
                              row={true}
                            >
                              <FormControlLabel
                                value="E"
                                control={<Radio />}
                                label="Evet"
                              />
                              <FormControlLabel
                                value="H"
                                control={<Radio />}
                                label="Hayır"
                              />
                            </RadioGroup>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mt-sm-2 mt-xxl-0 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <h5 className="mb-3 font-weight-bold">BAŞVURU BİLGİLERİ</h5>
                    <hr className="mb-3" />
                    <div className="row">
                      <div className="row w-100 m-0 mb-3">
                        <div className="col-lg-6 p-0 px-lg-2 ps-lg-0 mb-3 mb-lg-0">
                          <div className="card w-100">
                            <div className="card-body w-100">
                              <h6>Kimlik Bilginiz Gizlensin mi?</h6>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                {...formikProps.getFieldProps(
                                  "kimlikBilgilerimiGizle"
                                )}
                                defaultValue={
                                  formikProps.values.kimlikBilgilerimiGizle
                                }
                                row={true}
                              >
                                <FormControlLabel
                                  value="E"
                                  control={<Radio />}
                                  label="Evet"
                                />
                                <FormControlLabel
                                  value="H"
                                  control={<Radio />}
                                  label="Hayır"
                                />
                              </RadioGroup>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 p-0 px-lg-2 pe-lg-0">
                          <div className="card w-100">
                            <div className="card-body w-100">
                              <h6>SMS İle Bilgilendirme</h6>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue={
                                  formikProps.values.smsBildirimiIstiyorum
                                }
                                {...formikProps.getFieldProps(
                                  "smsBildirimiIstiyorum"
                                )}
                                row={true}
                              >
                                <FormControlLabel
                                  value="E"
                                  control={<Radio />}
                                  label="Evet"
                                />
                                <FormControlLabel
                                  value="H"
                                  control={<Radio />}
                                  label="Hayır"
                                />
                              </RadioGroup>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row pe-0">
                        <div className="col-12 pe-0">
                          <CustomTextField
                            id="outlined-multiline-flexible"
                            label="Başvuru Metni *"
                            error={
                              formikProps.errors.basvuruMetni &&
                                formikProps.touched.basvuruMetni
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("basvuruMetni")}
                            rows={7.6}
                            fullWidth
                            multiline
                            maxRows={10}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div ref={documentTableRef}>
                {!docsLoaded ? (
                  <div className="d-flex justify-content-center my-2"><CircularProgress size={24} /></div>
                ) : (
                  <DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} />
                )}
              </div>
              <div className="col-12 mt-3">
                <div className="d-flex justify-content-end align-self-stretch">
                  <Recaptcha
                    ref={recaptchaRef}
                    changeHandleRecaptcha={setRecaptchaPassed}
                  />
                  <Button


                    type="submit"
                    onClick={() => showToastIfErrorsExist()}

                  >
                    Gönder
                  </Button>
                  {loadingSubmit && (
                    <div
                      style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(255,255,255,0.6)",
                        zIndex: 1300,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  )}
                </div>
              </div>
              {isPopupVisible ? (
                <BilgilendirmePopup
                  basvuruTuruId={formikProps.values.basvuruTuruId}
                  isSorunBildirPopup={!kayitBasarili}
                  closePopup={closePopupSonuc}
                  open={isPopupVisible}
                  editDescription={popupbasvuruMetni}
                />
              ) : null}

            </div>
          </Form>
        )
      }
      }
    </Formik>
  );
};
export default IstekSikayetBasvuru;
